/* eslint-disable no-undef */
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { assingInputValueByName } from 'crk-front-lib/tools/dom-util';

const payChannels = require('../configs/payment-channel.json');

export function PaymentPage(props) {
  const [lblFileName, setLblFileName] = useState('รูปภาพสลิปชำระเงิน');
  const history = useHistory();

  const location = useLocation();
  const params = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]) 

  const refDateInput = useRef(null);
  const refSubmitButton = useRef(null);
  const refProgressDiv = useRef(null);

  useEffect(() => {
    // if (initialized) return;
    if (params.has('bill_no')) assingInputValueByName('pay_bill_no', params.get('bill_no'));
    if (params.has('pay_amt')) assingInputValueByName('pay_amt', params.get('pay_amt'));
    if (params.has('pay_memo')) assingInputValueByName('pay_memo', params.get('pay_memo'));

    $(refDateInput.current).datepicker('destroy');

    $(refDateInput.current)
      .datepicker({
        language: 'th', // props.app.lang || props.lang || 'th',
        format: 'd M yyyy',
      })
      .on('changeDate', (e) => {
        // const _date = e.date;
      });

  }, [params, props]);

  const handleResetCaptcha = useCallback(() => {
    const _img = document.getElementById('img_captcha');
    _img.src = '/api/v2/captcha?t=' + new Date().getTime();
  }, []);

  const handleBrowseFile = useCallback((e) => {
    console.info(e.target.files);
    if (e.target.files.length > 0) {
      setLblFileName(e.target.files[0].name);
    }
  }, [])

  const handleSubmit = useCallback(() => {
      const formdata = new FormData(document.getElementById('payform'));
      for (const k of formdata.keys()) {
        if (formdata.get(k) === '') {
          showAlert('กรุณากรอกข้อมูลให้ครบทุกช่อง', 'danger', true);
          return;
        }
      }

      refSubmitButton.current.classList.add("invisible");
      refProgressDiv.current.classList.remove("invisible");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };
      
      fetch("/api/v2/payment", requestOptions)
      .then(response => {
        refSubmitButton.current.classList.remove("invisible");
        refProgressDiv.current.classList.add("invisible");
  
        return response.json();
      })
      .then(result => {
        if(result.status===200 && result.code==='OK') {
          // if(success) success(result.data)
          console.info(result.data);
          history.push('/thank-payment');
        } else {
          console.info(result);
          if (result.message.match(/bill.*not correct/i)) {
            showAlert('ป้อนเลขที่ใบแจ้งหนี้ไม่ถูกต้อง', 'danger');
          } else {
            showAlert(result.message, 'danger');
          }
        }
      })
      .catch(error => {
        console.error('error', error);
        if (error.message.match(/bill.*not correct/i)) {
          showAlert('ป้อนเลขที่ใบแจ้งหนี้ไม่ถูกต้อง', 'danger');
        } else {
          showAlert(error.message, 'danger');
        }
      });	      
    },[history])

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-5 d-none d-lg-block bg-register-image my-1"></div>
        <div className="col-lg-5 offset-lg-2">
          <h2 className="text-black">แจ้งชำระเงิน</h2>
          <form id="payform">
            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputChannel">ช่องทางการชำระเงิน</label>
                <select name="pay_channel" id="inputChannel" className="form-control" defaultValue="">
                  <option value="">เลือก...</option>
                  {payChannels.map((c, i) => {
                    return (
                      <option key={i} value={c.code}>
                        {c.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputAmount">จำนวนเงิน</label>
                <input name="pay_amt" id="inputAmount" className="form-control" autoComplete="off" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputDate">วันที่</label>
                <input ref={refDateInput} name="pay_date" id="inputDate" className="form-control" autoComplete="off" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputTime">เวลา</label>
                <input name="pay_time" id="inputTime" className="form-control" autoComplete="off" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputRefNo">เลขที่ใบสั่งซื้อ/ใบแจ้งหนี้</label>
                <input
                  name="pay_bill_no"
                  id="inputRefNo"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Purchase No / Bill No"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-10">
                <label htmlFor="inputRefNo">หลักฐานการชำระเงิน</label>
                <div className="input-group mb-3">
                  <div className="custom-file">
                    <input
                      type="file"
                      name="file"
                      onChange={handleBrowseFile}
                      className="custom-file-input"
                      id="inputGroupFile01"
                      autoComplete="off"
                    />
                    <label className="custom-file-label" htmlFor="inputGroupFile01">
                      {lblFileName}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputMemo">ข้อความถึงผู้ขาย</label>
                <input
                  name="pay_memo"
                  id="inputMemo"
                  className="form-control"
                  placeholder="ชื่อโปรแกรม หรือ ชื่อบริษัท"
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-10">
                <label htmlFor="inputCaptcha">ป้อนรหัสความปลอดภัย</label>
                <input name="captcha" id="inputCaptcha" className="form-control" autoComplete="off" />
              </div>
            </div>

            <img id="img_captcha" src="/api/v2/captcha" alt="captcha" />
            <button type="button" className="btn" onClick={handleResetCaptcha}>
              <i className="fas fa-sync-alt"></i>
            </button>
            <p>รหัสความปลอดภัย</p>

            <div className="form-row">
              <div className="col">
                <button ref={refSubmitButton} type="button" onClick={handleSubmit} className="btn btn-success btn-lg">
                  ยืนยัน
                </button>
                <div ref={refProgressDiv} className="progress invisible">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: '75%' }}
                  ></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <hr />
      <ChannelDetail />
      <br />
      <div className="row">
        <div className="col">
          <p>
            เมื่อแจ้งชำระเงินแล้ว รอเจ้าหน้าที่ตรวจสอบความถูกต้องของข้อมูล ภายใน 12 ชั่วโมง
            <br />
            จะมีอีเมล์แจ้งสถานะการขำระเงินให้ทราบ หากเกินเวลาที่แจ้งไว้ กรุณาติดต่อเจ้าหน้าที่
          </p>
          <a
            href="https://web.crksolution.com/#contact"
            target="_blank"
            rel="noreferrer"
            className="btn btn-sm btn-link"
          >
            ติดต่อเรา
          </a>
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

function ChannelDetail() {
  return <>
  <h3 className="mb-2">ช่องทางการชำระเงิน :-</h3>
  <div className="row">
    <div className="col-md-6 mb-4">
      <table className="w-100">
        <tbody>
          <tr>
            <td rowSpan="3" style={{width: '90px'}}>
              <img src="/scb-logo-01.png" alt="SCB" style={{width: '75px', height: '75px'}} />
            </td>
            <td className="w-25"><h5>ธนาคาร :</h5></td>
            <td><h5>ไทยพาณิชย์</h5></td>
          </tr>
          <tr>
            <td>เลขบัญชี :</td>
            <td>431-049974-9</td>
          </tr>
          <tr>
            <td>ชื่อบัญชี :</td>
            <td>บริษัท ซีอาร์เค โซลูชั่น จำกัด</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="col-md-6 mb-4">
    <table className="w-100">
        <tbody>
          <tr>
            <td rowSpan="3" style={{width: '90px'}}>
              <img src="/kbank-logo-01.png" alt="SCB" style={{width: '75px', height: '75px'}} />
            </td>
            <td className="w-25"><h5>ธนาคาร :</h5></td>
            <td><h5>กสิกรไทย</h5></td>
          </tr>
          <tr>
            <td>เลขบัญชี :</td>
            <td>660-2-21075-6</td>
          </tr>
          <tr>
            <td>ชื่อบัญชี :</td>
            <td>บริษัท ซีอาร์เค โซลูชั่น จำกัด</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div className="row">
    <div className="col-md-6 mb-4">
      <table className="w-100">
        <tbody>
          <tr>
            <td rowSpan="3" style={{width: '90px'}}>
              <img src="/true-money-01.png" alt="SCB" style={{width: '75px', height: '75px'}} />
            </td>
            <td className="w-25"><h5>Wallet :</h5></td>
            <td><h5>True Money</h5></td>
          </tr>
          <tr>
            <td>เลขบัญชี :</td>
            <td>086-564-0541</td>
          </tr>
          <tr>
            <td>ชื่อบัญชี :</td>
            <td>รุ่งนภา แก้วทวี</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="col-md-6 mb-4">
    <table className="w-100">
        <tbody>
          <tr>
            <td rowSpan="3" style={{width: '90px'}}>
              <img src="/crk-logo-04.png" alt="CRK" style={{width: '75px', height: '75px'}} />
            </td>
            <td className="w-25"><h5>อื่น ๆ :</h5></td>
            <td><h5>ติดต่อเจ้าหน้าที่</h5></td>
          </tr>
          <tr>
            <td>มือถือ :</td>
            <td>086-564-0541</td>
          </tr>
          <tr>
            <td>LINE :</td>
            <td>rung.crk</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>  
  </>
}